// extracted by mini-css-extract-plugin
export default {"card":"ProjectCard_card__fLuSa","info":"ProjectCard_info__mGiUu"};